"use client"

import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Products } from "@/types/productsTypes";

export function Metrics({ section }: { section: Products["atlasai"]["metrics"] }) {
    return (
        <section className="section-primary">
            <div className="max-w-6xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <span className="section-badge badge-size inline-block w-fit">
                        {section.badge}
                    </span>
                    <h2 className="title-size font-semibold text-bg">
                        {section.title}
                    </h2>
                    <p className="text-size text-muted-foreground max-w-3xl mx-auto">
                        {section.description}
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-3">
                    {section.stats.map((stat, index) => (
                        <motion.div
                            key={stat.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="rounded-3xl border bg-white p-6 text-center shadow-sm"
                        >
                            <div className="text-4xl font-bold text-primary-600 mb-2">
                                {stat.value}
                            </div>
                            <p className="text-sm font-semibold text-bg mb-1">
                                {stat.label}
                            </p>
                            <p className="text-xs text-muted-foreground">
                                {stat.caption}
                            </p>
                        </motion.div>
                    ))}
                </div>

                <div className="grid gap-6 md:grid-cols-2">
                    {section.testimonials.map((quote, index) => (
                        <motion.blockquote
                            key={quote.author}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="rounded-3xl border bg-white p-6 shadow-sm"
                        >
                            <Quote className="size-8 text-secondary-500 mb-4" />
                            <p className="text-sm text-muted-foreground mb-4">
                                {quote.quote}
                            </p>
                            <cite className="text-sm font-semibold text-bg not-italic">
                                {quote.author}
                            </cite>
                            <p className="text-xs text-muted-foreground">
                                {quote.role}
                            </p>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
}
